import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

import AddAdvertiser from '@/components/advertiser/AddAdvertiser'
import ListAdvertiser from '@/components/advertiser/ListAdvertisers'
import AddAdvertiserUrl from '@/components/advertiser/AddAdvertiserUrl'
import ListAdvertiserUrls from '@/components/advertiser/ListAdvertiserUrls'
import EditAdvertiserUrl from '@/components/advertiser/EditAdvertiserUrl'


import AddNetwork from '@/components/network/AddNetwork'
import ListNetwork from '@/components/network/ListNetwork'
import AddNetworkUrl from '@/components/network/AddNetworkUrl'
import ListNetworkUrl from '@/components/network/ListNetworkUrl'
import ManualPostback from '@/components/network/ManualPostback'

import AddOperator from '@/components/operator/AddOperator'
import ListOperator from '@/components/operator/ListOperator'

import CountryMng from '@/components/country/CountryMng'

import ReportDashboard from '@/components/report/ReportDashboard'
import DollarSetting from '@/components/setting/Dollar'

import DeleteClicks from '@/components/delete/DeleteClicks'
import DeleteClickInfo from '@/components/delete/DeleteClickInfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/advertiser/add',
      name: 'addAdvertiser',
      component: AddAdvertiser
    },
    {
      path: '/advertiser/view',
      name: 'listAdvertiser',
      component: ListAdvertiser
    },
    {
      path: '/advertiser/addUrl',
      name: 'addAdvertiserUrl',
      component: AddAdvertiserUrl
    },
    {
      path: '/advertiser/editUrl/:savedAdvertiserUrlId',
      name: 'editAdvertiserUrl',
      component: EditAdvertiserUrl,
      props: true
    },
    {
      path: '/advertiser/viewUrls',
      name: 'listAdvertiserUrls',
      component: ListAdvertiserUrls
    },
    {
      path: '/network/add',
      name: 'addNetwork',
      component: AddNetwork
    },
    {
      path: '/network/view',
      name: 'listNetwork',
      component: ListNetwork
    },
    {
      path: '/network/addUrl',
      name: 'addNetworkUrl',
      component: AddNetworkUrl
    },
    {
      path: '/network/viewUrl',
      name: 'listNetworkUrl',
      component: ListNetworkUrl
    },
    {
      path: '/network/manualPostback',
      name: 'manualPostback',
      component: ManualPostback
    },
    {
      path: '/operator/add',
      name: 'addOperator',
      component: AddOperator
    },
    {
      path: '/operator/view',
      name: 'listOperator',
      component: ListOperator
    },
    {
      path: '/country/update',
      name: 'updateCountry',
      component: CountryMng
    },
    {
      path: '/report/dashboard',
      name: 'newDashboard',
      component: ReportDashboard
    },
    {
      path: '/setting/dollar',
      component: DollarSetting
    },
    {
      path: '/delete/clicks',
      component: DeleteClicks
    },
    {
      path: '/delete/clickinfo',
      component: DeleteClickInfo
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js